<template>
  <span @click="$emit('click', $event)" :id="id">
    <inline-svg v-if="isSvg" :src="src" @loaded="svgLoaded" :width="width || getSize.width" :height="height || getSize.height" :class="getSvgClasses"></inline-svg>
		<img v-else :src="src" :width="width || getSize.width" />
  </span>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
import { SMALL_SIZE, MEDIUM_SIZE, LARGE_SIZE } from '@/constants/sizes'
import { WHITE_COLOUR, BLUE_COLOUR, RED_COLOUR, GRAY_COLOUR, GREEN_COLOUR } from '@/constants/colours'

export default {
  name: 'base-icon',
  components: {
    'inline-svg': InlineSvg
  },
  data () {
    return {
      id: null
    }
  },
  props: {
    src: {
      type: String
    },
    color: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: [String],
      required: false,
      validator (value) {
        return value === SMALL_SIZE || value === MEDIUM_SIZE || value === LARGE_SIZE
      },
      default () {
        return SMALL_SIZE
      }
    },
    width: {
      type: [Number, String],
      required: false
    },
    height: {
      type: [Number, String],
      required: false
    },
    svgClasses: {
      type: String,
      required: false
    },
    blue: Boolean,
    green: Boolean,
    white: Boolean,
    red: Boolean,
    gray: Boolean,
    fullWidth: Boolean,
    shadow: Boolean,
    reverse: Boolean
  },
  computed: {
    getSize () {
      let size = {}
      if (this.fullWidth) {
        const full = '100%'
        size.width = full
        size.height = full
      } else {
        switch (this.size) {
					case SMALL_SIZE:
						size.width = 17
						size.height = 17
						break
					case MEDIUM_SIZE:
						size.width = 30
						size.height = 30
						break
					case LARGE_SIZE:
						size.width = 50
						size.height = 50
						break
				}
			}
      return size
    },
    getSvgClasses () {
      let classes = this.svgClasses
      if (this.shadow) {
        classes += ' svg-shadow'
      }
      if (this.reverse) {
        classes += ' reverse'
      }
      return classes ? classes.trim() : ''
    },
		isSvg () {
			return this.src && this.src.includes('.svg')
		}
  },
  watch: {
    color: function (newColor) {
      this.updateSvgStyles(newColor)
    },
    blue (isBlue) {
      if (isBlue) {
        this.updateSvgStyles(this.getColor(true))
      }
    },
    green (isGreen) {
      if (isGreen) {
        this.updateSvgStyles(this.getColor(true))
      }
    },
    white (isWhite) {
      if (isWhite) {
        this.updateSvgStyles(this.getColor(true))
      }
    },
    red (isRed) {
      if (isRed) {
        this.updateSvgStyles(this.getColor(true))
      }
    },
    gray (isGray) {
      if (isGray) {
        this.updateSvgStyles(this.getColor(true))
      }
    }
  },
  methods: {
    updateSvgStyles (color) {
			const elem = document.getElementById(this.id)
			if (!elem) { return }
			const paths = elem.querySelectorAll('path')
			if (paths.length === 0) { return }
      paths.forEach((elem) => {
        let modified = false
        if (elem.style.fill || (elem.outerHTML.includes('fill="') && !elem.outerHTML.includes('fill="none"'))) {
          elem.style.fill = color
          modified = true
        }
        if (elem.style.stroke || (elem.outerHTML.includes('stroke="') && !elem.outerHTML.includes('stroke="none"'))) {
          elem.style.stroke = color
          modified = true
        }
        if (!modified) {
          elem.style.fill = color
        }
      })
			const rects = elem.querySelectorAll('rect')
			if (rects.length === 0) { return }
      rects.forEach((elem) => {
        elem.style.fill = color
      })
    },
    svgLoaded () {
      this.updateSvgStyles(this.getColor())
    },
    getColor (onlyColorProps = false) {
      if (!this.color || onlyColorProps) {
        if (this.blue) {
          return BLUE_COLOUR
        } else if (this.green) {
          return GREEN_COLOUR
        } else if (this.white) {
          return WHITE_COLOUR
        } else if (this.red) {
           return RED_COLOUR
        } else {
          // default
           return GRAY_COLOUR
        }
      } else {
        return this.color
      }
    }
  },
  mounted () {
    this.id = this._uid.toString()
  }
}
</script>

<style lang="scss">

svg.svg-shadow {
  box-shadow: none !important;
  /* filter: drop-shadow(-14px -14px 23px #fff) drop-shadow(14px 14px 25px rgba(13,39,80,0.160784)) */
  filter: drop-shadow(-15px -14px 20px #fff) drop-shadow(15px 14px 20px rgba(13,39,80,0.3));
}

svg.reverse {
  transform: scale(-1,1);
}
</style>


// WEBPACK FOOTER //
// src/components/base/icons/BaseIcon.vue